import { MechanicAssignment } from "src/app/features/reefer-mechanic/interfaces/mechanic-assignment.interface";
import { SelectOption } from "src/app/shared/interfaces/select-option.interface";

export class ReeferMechanicStateModel {
  orders: SelectOption[];
  assignments: MechanicAssignment[];
  loading: boolean;
}